module.exports = __webpack_public_path__ + "2893264d2d8bedf51798af9fcd17efc4.png";